/* global $ */

class SpMenu {
  constructor(mainApp) {
    this.mainApp      = mainApp;
    this.$container   = $('.SpMenu');
    this.isOpen       = false;
    this.menuList = [];

    this.$container.find('.SpMenuListItem').each((i, e) => {
      this.menuList.push($(e));
    });


    $('.BtnToggleMenu').on('click', () => {
      if(this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
  }
  open() {
    if(!this.isOpen) {
      for(let i = 0; i < this.menuList.length; i++) {
        this.menuList[i].stop(false).css({
          'opacity': 0,
          'margin-left': 30
        });
      }
      this.isOpen = true;
      $('body').addClass('sp-open-menu');
      this.$container.stop(false).css({
        'opacity': 1,
        'pointer-events': 'auto'
      });
      setTimeout(() => {
        for(let i = 0; i < this.menuList.length; i++) {
          this.menuList[i].stop(false).delay(i * 35).animate({'opacity': 1, 'margin-left': 0}, 600, 'easeOutExpo');
        }
      }, 50);
    }
  }
  close() {
    if(this.isOpen) {
      $('body').removeClass('sp-open-menu');
      this.isOpen = false;
      this.$container.animate({'opacity':0}, 500, 'easeOutExpo', () => {
        this.$container.css({
          'pointer-events': 'none'
        });
      });
      /*
      this.$container.css({
        'opacity': 0,
        'pointer-events': 'none'
      });
      */
    }
  }
}

export default SpMenu;
